import { useInView } from "react-intersection-observer";
import { Suspense } from "react";

export function LazySection({ children }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "300px",
  });

  return (
    <div ref={ref}>
      {inView && (
        <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
      )}
    </div>
  );
}
